import { useMemo } from "react";

import { useDemandHistory, useForecast } from "@/api/demandForecast";
import type { DemandHistoryPoint } from "@/api/demandForecast";
import type { Mode } from "@/components/demand-chart/types";

/** Fetches the item's full daily history (for the chosen mode) + its forecast. */
export function useChartData(
  itemId: number,
  locationIds: number[],
  mode: Mode,
) {
  const historyQuery = useDemandHistory({
    item: itemId,
    locations: locationIds,
    mode,
  });
  const forecastQuery = useForecast(itemId, locationIds);

  const buckets = useMemo((): DemandHistoryPoint[] => {
    const data = historyQuery.data;
    if (!data) return [];
    return (data.groups[0]?.points ?? []).map((p) => ({
      date: p.date,
      quantity: p.quantity,
      revenue: p.revenue,
    }));
  }, [historyQuery.data]);

  return { historyQuery, forecastQuery, buckets };
}
